import { render, staticRenderFns } from "./rubbishSortCamera.vue?vue&type=template&id=37a10d4f&scoped=true"
import script from "./rubbishSortCamera.vue?vue&type=script&lang=js"
export * from "./rubbishSortCamera.vue?vue&type=script&lang=js"
import style0 from "./rubbishSortCamera.vue?vue&type=style&index=0&id=37a10d4f&prod&lang=less&scoped=true"
import style1 from "./rubbishSortCamera.vue?vue&type=style&index=1&id=37a10d4f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a10d4f",
  null
  
)

export default component.exports